import { render, staticRenderFns } from "./VoucherCpfBlock.vue?vue&type=template&id=e0782536"
import script from "./VoucherCpfBlock.vue?vue&type=script&lang=js"
export * from "./VoucherCpfBlock.vue?vue&type=script&lang=js"
import style0 from "./VoucherCpfBlock.vue?vue&type=style&index=0&id=e0782536&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports